<div class="jobs-nearby-list-page-wrapper">
  <div class="page-content-wrapper">
    <div class="job-content">
      <div class="job-content-filter">
        <form class="filter-form" (ngSubmit)="applyFilters()">
          <div class="form-row">
            <div class="filter-wrapper title-filter">
              <label class="filter-label" for="inputState">Job Title</label>

              <div class="filter-select-wrapper">
                <mat-form-field class="job-profession-select-wrapper" appearance="outline" subscriptSizing="dynamic">
                  <mat-select placeholder="Choose Job Title" [(ngModel)]="professionFilter"
                    name="profession" (closed)="titleDropdownSelectClose()"
                    [compareWith]="compareStringValuesFn" [disabled]="jobTitleDisabled" panelClass="job-profession-select-panel">
                    <input class="custom-inner-dropdown-filter-input" matInput type="text"
                      placeholder="Title Filter" [(ngModel)]="titleDropdownFilter"
                      [ngModelOptions]="{standalone: true}" (keyup)="applyTitleDropdownFilter()"
                      (keydown)="$event.stopPropagation()" autocomplete="off">
                    @for (_job of filteredJobTitles; track _job) {
                      <mat-option class="job-profession-select-option" [value]="_job?.profession">{{ _job?.name }}</mat-option>
                    }
                  </mat-select>
                  @if (professionFilter) {
                    <button mat-button matSuffix mat-icon-button
                      aria-label="Clear" (click)="clearTitle($event)">
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                </mat-form-field>
              </div>
            </div>

            <div class="filter-btn-wrapper">
              <button type="submit" class="btn filter-button search-filter-btn">Filter Jobs</button>
              <button type="button" class="btn filter-button clear-filter-btn" (click)="clearFilteredResults()">Clear</button>
            </div>
          </div>
        </form>
      </div>

      @if (jobs && jobs.length > 0) {
        <div class="job-content-list">
          @for (_job of jobs; track _job) {
            <div class="job-content-item">
              <div class="featured-ribbon"><span>FEATURED</span></div>
              <h2 class="job-name"><span (click)="sendToDetails(_job)">{{ _job.name }}</span></h2>
              <div class="details-row">
                <div class="job-setting">Setting: {{ (_job.setting && _job.setting !== undefined) ? _job.setting : 'School' }}</div>
                <div class="job-location">
                  Location:
                  @if (_job.city) {
                    <span>{{ _job.city }}, </span>
                  }
                  @if (_job.state) {
                    <span>{{ _job.state }}</span>
                  }
                </div>
                <div class="job-age"><span class="age-label"></span></div>
              </div>
              <div class="job-description" [innerHTML]="(_job.short_job_description | ellipsis: 420) | safeHtml">
              </div>
            </div>
          }
        </div>
      }

      @if (!jobs || jobs.length <= 0) {
        <div class="job-content-list">
          <div class="job-content-item">
            <p class="no-content">No content found</p>
          </div>
        </div>
      }
    </div>
  </div>
</div>